import {z} from 'zod';

export const ChatFeedbackRatingSchema = z.enum(['up', 'down']);
export const ChatFeedbackMessageKeySchema = z.string().regex(/^(?:logical:[0-9a-f]{64}|row:[1-9][0-9]{0,15})$/);
export const ChatFeedbackEntrySchema = z.object({
  nativeSessionId: z.string().min(1).max(300),
  messageKey: ChatFeedbackMessageKeySchema,
  messageRowId: z.number().int().positive().max(Number.MAX_SAFE_INTEGER),
  rating: ChatFeedbackRatingSchema,
  updatedAt: z.iso.datetime(),
}).strict();
export const ChatFeedbackListSchema = z.object({
  sessionId: z.string().min(1).max(300),
  feedback: z.array(ChatFeedbackEntrySchema),
}).strict();
export const ChatFeedbackResultSchema = ChatFeedbackEntrySchema.extend({
  rating: ChatFeedbackRatingSchema.nullable(),
  updatedAt: z.iso.datetime().nullable(),
});
export type ChatFeedbackRating = z.infer<typeof ChatFeedbackRatingSchema>;
export type ChatFeedbackEntry = z.infer<typeof ChatFeedbackEntrySchema>;
